import React from 'react'
import '../assets/css/style.css';
import '../style/HomeScreen.css';
const HeroUI = ({ displaySet }) => {
  return (
    <section id="hero">
      <div className="container">
        <div className="row">
          <div className='col-lg-12'><p className='moving_text'><span>Floating Rate Savings Bond 2020</span> is now available on RBI Retail Direct Portal!</p></div>
          <div className="col-lg-8 pt-5 pt-lg-0 order-2 order-lg-1 d-flex align-items-center">
            <div style={{ marginTop: "-100px" }}>

              <h1>
                <span id="wordChanger">Invest in Government Securities</span>
              </h1>
              <h2>Safe... Simple... Direct !!!</h2>
              <div className="text-center text-lg-left">
                <a
                  href="https://rbiretaildirect.in/#/rdg-account-registration"
                  target="_blank"
                  className="btn-get-started"
                >
                  Open RBI Retail Direct Account
                </a>

                <i
                  title="How to register?"
                  className="ri-information-line icon-info"
                  onClick={() => displaySet(true)}></i>

              </div>
              <h3>
                Already registered? Login into
                <div style={{ display: "inline-block", whiteSpace: "nowrap" }}>
                  <a
                    href="https://rbiretaildirect.in"
                    target="_blank"
                    data-toggle="tooltip"
                    data-placement="top"
                    title="Login for Primary Auction Bidding"
                  >
                    <i className="ri-user-shared-line"></i> RBI Retail Direct
                    Account
                  </a>
                  /
                  <a
                    href="https://retail.ndsom.com"
                    target="_blank"
                    data-toggle="tooltip"
                    data-placement="top"
                    title="Login for Secondary Market Trading after activating access from RBI Retail Direct Account"
                  >

                    <i className="ri-line-chart-line"></i> NDS-OM Secondary
                    Market
                  </a>
                </div>
              </h3>
            </div>
          </div>
          <div className="col-lg-4 order-1 order-lg-2 hero-img">
            <img
              src="https://rbiretaildirect.org.in/common/img/svg/rbi.svg"
              className="img-flui animated rbiSeal"
              alt="RBI Seal"
            />
          </div>
        </div>
      </div>
    </section>)
}; export default HeroUI